import axios from '@utils/axios-client'

export async function fetchStore (id: string) {
  const response = axios.get(`/api/v1/Store/${id}`)
  return (await response).data
}

export async function fetchVideoGoLiverByStoreId (params: any) {
  const response = axios.get('/api/v1/VideoGoLiver/GetByStoreId', { params })
  return (await response).data
}

export async function fetchStoreVideoGoLiverSummary (params: any) {
  const response = axios.get('/api/v1/Store/GetGoLiverCountLiked', { params })
  return (await response).data
}
